import Footer from "./Footer";
import Header from "./Header";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-blue-50 dark:bg-gray-900">
      <Header />
      <div className="max-w-3xl mx-auto pt-28 pb-16 px-4">
        <h1 className="text-4xl md:text-5xl font-extrabold text-primary-blue mb-6 text-center">Contact Us</h1>
        <p className="text-lg text-gray-700 dark:text-gray-300 mb-10 text-center font-medium">
          Have a question, need support, or want to learn more about Accurix? Fill out the form below or reach out to us directly.
        </p>
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 border border-blue-100 dark:border-gray-700 mb-10">
          <form className="space-y-6">
            <div>
              <label className="block text-gray-700 dark:text-gray-300 font-semibold mb-1">Name</label>
              <input type="text" className="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-blue" placeholder="Your name" required />
            </div>
            <div>
              <label className="block text-gray-700 dark:text-gray-300 font-semibold mb-1">Email</label>
              <input type="email" className="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-blue" placeholder="you@email.com" required />
            </div>
            <div>
              <label className="block text-gray-700 dark:text-gray-300 font-semibold mb-1">Message</label>
              <textarea className="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-blue" rows={5} placeholder="How can we help you?" required />
            </div>
            <button type="submit" className="w-full bg-primary-blue text-white py-3 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors shadow">Send Message</button>
          </form>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-gray-700 dark:text-gray-300 text-base font-medium">
          <div className="flex items-center gap-2"><Mail className="h-5 w-5 text-primary-blue" /> support@accurix.com</div>
          <div className="flex items-center gap-2"><Phone className="h-5 w-5 text-primary-blue" /> +234 800 000 0000</div>
          <div className="flex items-center gap-2"><MapPin className="h-5 w-5 text-primary-blue" /> Lagos, Nigeria</div>
        </div>
      </div>
      <Footer/>
    </div>
  );
} 